<template>
  <div class="h-100 company-home">
    <div :style="bg1Style" class="vertical-jumbotron">
      <h1>Canal de Denúncias<br />da GEP Compliance</h1>
      <p>
        Este canal foi criado para que colaboradores, parceiros e demais
        stakeholders da GEP Compliance possam relatar, de forma segura e
        confidencial, qualquer conduta inadequada, infração legal ou violação
        ética. Seu relato será tratado com sigilo absoluto, e sua identidade
        será protegida.
      </p>
      <p>
        A GEP Compliance valoriza a transparência e a integridade, garantindo
        que todas as denúncias recebidas sejam analisadas de forma responsável.
      </p>
      <b-btn
        v-if="hasComplaintsModule"
        variant="primary"
        :to="`/${getRoute('report', hasAlternateComplaintForm)}`"
        size="lg"
        class="m-2"
      >
        {{
          hasAlternateComplaintForm
            ? $t("home.btn.communicate")
            : $t("home.btn.report")
        }}
      </b-btn>
      <b-btn
        v-if="hasComplaintsModule"
        variant="primary"
        :to="`/${getRoute('follow-up')}`"
        size="lg"
        class="m-2"
      >
        {{ $t("home.btn.followup") }}
      </b-btn>
    </div>
    <div class="jumbotron-divider">
      <img :src="logo" crossorigin="anonymous" alt="logo" />
      <div>
        <h1>Canal Independente e Seguro</h1>
        <p>
          Este canal é administrado de forma independente pela GEP Compliance,
          garantindo um ambiente seguro e sigiloso para o registro de denúncias.
          Todas as informações serão tratadas com confidencialidade e
          responsabilidade.
        </p>
      </div>
    </div>
    <div :style="bg2Style" class="vertical-jumbotron">
      <h1>Compromisso com a Ética e a Transparência</h1>

      <p>
        Nosso canal de denúncias foi criado exclusivamente para receber relatos
        sobre comportamentos antiéticos ou violações de leis e normas
        relacionadas à GEP Compliance e suas partes interessadas. Sua
        contribuição é essencial para mantermos um ambiente íntegro e alinhado
        com nossos valores.
      </p>
      <p>
        Caso tenha dúvidas ou precise de mais informações, convidamos você a
        acessar nosso Código de Conduta. Além disso, queremos reforçar que a GEP
        não tolera qualquer forma de retaliação, discriminação ou penalização
        contra aqueles que fazem denúncias de boa-fé. Aqui, acreditamos que agir
        com integridade fortalece a nossa cultura e gera valor para todos.
      </p>
      <b-btn
        variant="primary"
        :to="`/${getRoute('follow-up')}`"
        size="lg"
        class="m-2"
      >
        Código de Conduta
      </b-btn>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { Routes } from "@/i18n";

export default {
  name: "CompanyHome",
  computed: {
    ...mapGetters(["company", "portal", "portalBucket"]),
    logo() {
      return `https://${this.portalBucket}/${this.portal._id}/${this.portal?.logo}`;
    },
    bg1() {
      return `https://${this.portalBucket}/${this.portal._id}/bg1.png`;
    },
    bg1Style() {
      const bg = `url(${this.bg1})`;
      return `background-image: ${bg}`;
    },
    bg2() {
      return `https://${this.portalBucket}/${this.portal._id}/bg2.png`;
    },
    bg2Style() {
      const bg = `url(${this.bg2})`;
      return `background-image: ${bg}`;
    },
    title() {
      const lang = this.$i18n.locale;
      const portal = this.portal;
      if (
        portal &&
        portal.languages &&
        portal.languages[lang] &&
        portal.languages[lang].title
      )
        return portal.languages[lang].title;
      return this.$i18n.t("home.title", [this.company.fantasyName]);
    },
    introductionText() {
      const lang = this.$i18n.locale;
      const portal = this.portal;
      if (
        portal &&
        portal.languages &&
        portal.languages[lang] &&
        portal.languages[lang].introductionText
      )
        return portal.languages[lang].introductionText;
      return this.$i18n.t("home.introductionText", [this.company.fantasyName]);
    },
    instructionText() {
      const lang = this.$i18n.locale;
      const portal = this.portal;
      if (
        portal &&
        portal.languages &&
        portal.languages[lang] &&
        portal.languages[lang].instructionText
      )
        return portal.languages[lang].instructionText;
      return this.$i18n.t("home.instructionText", [this.company.fantasyName]);
    },
    phoneServiceText() {
      const lang = this.$i18n.locale;
      const portal = this.portal;
      if (
        portal &&
        portal.languages &&
        portal.languages[lang] &&
        portal.languages[lang].phoneServiceText
      )
        return portal.languages[lang].phoneServiceText;

      if (this.company.phoneService && this.company.phoneService.hasService) {
        const phone = this.company.phoneService.phone;
        return this.$i18n.t("home.phoneService", [phone]);
      }
      return "";
    },
    portalId() {
      return window.location.pathname
        .replace("/portal/", "")
        .replace(/\/+/g, "");
    },
    hasComplaintsModule() {
      return (
        this.company.modules.complaint && this.company.modules.complaint.enabled
      );
    },
    hasAlternateComplaintForm() {
      return (
        this.company.modules.complaint &&
        this.company.modules.complaint.alternateForm
      );
    },
  },
  methods: {
    getRoute(path, alt = false) {
      return Routes[`${path}${alt ? "Alt" : ""}`][this.$i18n.locale];
    },
  },
};
</script>

<style scoped lang="scss">
//.company-home {
//  margin: 0 -30px;
//  padding: 15px 30px 0;
//  position: relative;
//  overflow: hidden;
//}
//.bg-company-home {
//  z-index: -1;
//  margin: -15px -30px 0px;
//  width: 100%;
//  object-fit: cover;
//  position: absolute;
//  @media (max-width: 767px) {
//    display: none;
//  }
//}
//
//.custom-jumbotron {
//  margin-top: 15px;
//  border-radius: 75px;
//  padding-top: 30px;
//  padding-bottom: 30px;
//}
//
//.logo {
//  display: inline-block;
//  margin-top: 30px;
//  margin-right: -30px;
//  float: right;
//  width: 30%;
//}
//
//.logo img {
//  max-width: 100%;
//}
</style>
